import React, { Component } from 'react';
import './LoadingAndPulse.css';

export default class EmptyState extends Component {

  render () {
    const { image, icon, title, message, onClick } = this.props;
    return (
      <div className="col d-flex">
        <div className="m-auto text-center">
          { !!image && (
            <img
              width={ 60 }
              height={ 60 }
              src={ image }
              alt={ title }
              onClick={ onClick }
              className={ `${!!onClick ? 'clickable' : ''}` } />
          ) }
          { !!icon && (
            <i
              className={ `material-icons font-color-med ${!!onClick ? 'clickable' : ''}` }
              onClick={ onClick }>{ icon }</i>
          ) }
          { !!title && (
            <div
              className={ `font-size-lg font-weight-bold text-content mb-3 ${!!onClick
                ? 'clickable'
                : ''}` } onClick={ onClick }>
              { title }
            </div>
          ) }
          { !!message && <div className="font-size-md text-subtitle">{ message }</div> }
        </div>
      </div>
    );
  }
}
